import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as StyledCtaApartmentFilters from './ctaApartmentFilter.styles';
import {
	APARTMENT_LIST_FRONTPAGE_LOCATION_FILTER,
	APARTMENT_LIST_FRONTPAGE_ROOM_COUNT_FILTER,
	APARTMENT_LIST_FRONTPAGE_PRICE_FILTER,
} from '../../constants/contextMenus';
import { openContextMenu } from '../../actions/contextMenuActions';

const CtaApartmentFilters = ({
	filtersReducer,
	dispatch,
	url
}) => {
	const locationButton = useRef(null);
	const roomCountButton = useRef(null);
	const priceButton = useRef(null);
	const { selectedLocations, selectedRoomCount, selectedPrices } = filtersReducer;
	const filters = [
		{
			id: 1, label: 'Staðsetning', values: selectedLocations, menu: APARTMENT_LIST_FRONTPAGE_LOCATION_FILTER, ref: locationButton
		},
		{
			id: 2, label: 'Fjöldi herbergja', values: selectedRoomCount, menu: APARTMENT_LIST_FRONTPAGE_ROOM_COUNT_FILTER, ref: roomCountButton
		},
		{
			id: 3, label: 'Verð', values: selectedPrices, menu: APARTMENT_LIST_FRONTPAGE_PRICE_FILTER, ref: priceButton
		},
	];

	const onFilterClick = (menu, ref) => {
		const rect = ref.current.getBoundingClientRect();
		dispatch(openContextMenu(rect.x, (rect.y + rect.height + 10 + window.scrollY), menu));
	};

	return (
		<StyledCtaApartmentFilters.Wrapper>
			{
				filters.map(filter => (
					<StyledCtaApartmentFilters.FilterWrapper
						ref={filter.ref}
						key={filter.id}
						onClick={onFilterClick.bind(null, filter.menu, filter.ref)}>
						<StyledCtaApartmentFilters.FilterLabel>
							<span>{filter.label}</span>
						</StyledCtaApartmentFilters.FilterLabel>
						<StyledCtaApartmentFilters.FilterInput>
							{
								filter.values.length > 0 ? (
									filter.values[0].id
								) : <span>{filter.label}</span>
							}
						</StyledCtaApartmentFilters.FilterInput>
					</StyledCtaApartmentFilters.FilterWrapper>
				))
			}
			<StyledCtaApartmentFilters.ButtonWrapper>
				<Link to={url}>
					<StyledCtaApartmentFilters.StyledButton large primary>Leita að íbúð</StyledCtaApartmentFilters.StyledButton>
				</Link>
			</StyledCtaApartmentFilters.ButtonWrapper>
		</StyledCtaApartmentFilters.Wrapper>
	);
};

const mapStateToProps = ({ filtersReducer }) => ({
	filtersReducer
});

export default connect(mapStateToProps)(CtaApartmentFilters);
